// Curated, verified media for SeedKeepers Academy
export const MEDIA = {
  heroVideo: "https://videos.pexels.com/video-files/2878087/2878087-hd_1920_1080_24fps.mp4",
  heroPoster: "https://images.pexels.com/videos/2878087/free-video-2878087.jpg",

  landscape:
    "https://images.unsplash.com/photo-1635156612523-0dabd216974c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  sunrise:
    "https://images.unsplash.com/photo-1761878845376-e5561ddcc151?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  uluru:
    "https://images.unsplash.com/photo-1759479592479-62b10454e706?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",

  degraded:
    "https://images.unsplash.com/photo-1641966313604-20ee0b8db033?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  restored:
    "https://images.unsplash.com/photo-1782221587955-c7d594c23978?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",

  handsSeed:
    "https://images.unsplash.com/photo-1606825526800-a6d8eb537f0e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  seedPalm:
    "https://images.unsplash.com/photo-1598132393715-6538660246fa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  seedProcess:
    "https://images.unsplash.com/photo-1590039894211-67f4adc6392a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",

  floraRed:
    "https://images.unsplash.com/photo-1745508365435-9152ab5b75e2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  floraGreen:
    "https://images.unsplash.com/photo-1541437748616-60715173b70e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  floraWhite:
    "https://images.unsplash.com/photo-1774930724246-9b7f652a491a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  floraLeaves:
    "https://images.unsplash.com/photo-1684510459778-51433ae1178d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",

  nursery:
    "https://images.unsplash.com/photo-1637987327476-5c77df3cb16d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  seedTrays:
    "https://images.unsplash.com/photo-1624905918163-bd455354cfed?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",

  plantingWoman:
    "https://images.unsplash.com/photo-1551855350-c86caeaf8707?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  plantingGroup:
    "https://images.unsplash.com/photo-1598335624134-5bceb5de202d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  plantingHands:
    "https://images.unsplash.com/photo-1661100545029-cc3fd140dbfa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};
